import {toast} from 'react-toastify';  
import 'react-toastify/dist/ReactToastify.css';  
    
toast.configure()  
export function SuccessToast(msg){ 
    const notify = ()=>{ 
        toast.success(msg, {autoClose:3000})
    } 
    notify()  
} 